/*
 * Temporary compatibility layer for legacy GemPages galleries.
 *
 * GemPages stores a usable Shopify URL in data-src, but its lazy loader can
 * produce an invalid `https://cdn/shop/...` srcset while the theme is served
 * through Shopify CLI. Keep the gallery usable in local review without
 * editing generated gp-* files. This file can be removed after every PDP has
 * been republished with the current Product Images element.
 */
(() => {
  if (window.TallowVineGemPagesAdapter) return;
  window.TallowVineGemPagesAdapter = true;

  const isBrokenCliCdnUrl = (value = '') => /https:\/\/cdn\/shop\//i.test(value);

  const buildResponsiveSrcset = (source) => {
    const widths = [132, 240, 360, 480];
    const separator = source.includes('?') ? '&' : '?';

    return widths.map((width) => `${source}${separator}width=${width} ${width}w`).join(', ');
  };

  const hydrateImage = (image) => {
    const source = image.dataset.src || image.getAttribute('base-src');
    if (!source) return;

    const currentSrcset = image.getAttribute('srcset') || image.dataset.srcset || '';
    const needsSource = image.src.startsWith('data:image/');
    const needsSrcsetRepair = isBrokenCliCdnUrl(currentSrcset);

    if (needsSource) image.src = source;
    if (needsSrcsetRepair) image.srcset = buildResponsiveSrcset(source);
  };

  const hydrateLegacyImages = (root = document) => {
    root.querySelectorAll?.('img[data-src], img[base-src]').forEach(hydrateImage);
  };

  const applyStableAdapters = () => {
    if (!document.querySelector('gp-product')) return;

    document.body.classList.add('template-product', 'tv-gp-pdp');
    document.querySelectorAll('gp-product').forEach((element) => element.classList.add('tv-gp-buybox'));
    document.querySelectorAll('gp-product-images').forEach((element) => element.classList.add('tv-gp-gallery'));
    document.querySelectorAll('gp-product-button').forEach((element) => element.classList.add('tv-gp-atc'));

    const duplicatePromoRows = [...document.querySelectorAll('gp-row')].filter((row) => {
      const text = row.textContent?.replace(/\s+/g, ' ').trim() || '';
      return /Free Shipping Over \$?50/i.test(text) && /Summer Savings Event/i.test(text);
    });

    duplicatePromoRows.at(-1)?.classList.add('tv-gp-promo-duplicate');
  };

  const initialize = () => {
    applyStableAdapters();
    hydrateLegacyImages();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes' && record.target instanceof HTMLImageElement) {
        hydrateImage(record.target);
        return;
      }

      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node instanceof HTMLImageElement) hydrateImage(node);
        hydrateLegacyImages(node);
        applyStableAdapters();
      });
    });
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['src', 'srcset'],
  });
})();
